import axios from 'axios'

export default {
    get: () => axios.get('products'),
    getProduct: (id) => axios.get('products?id='+id),
    store: (data) => axios.post('products/store', data),
    update: (data) => axios.put('products/'+data.id, data),
    delete: (id) => axios.delete('products/'+id, ),
}